import { SelectDesignTokens } from "@primeuix/themes/types/select";
import { primitiveColorTokens, primitiveLayoutTokens } from "src/assets/layout/styles/tokens/primitive";

export const select: SelectDesignTokens = {
    root: {
        color: "{text.color}",
        borderRadius: "4px",
    },
    overlay: {
        borderRadius: primitiveLayoutTokens.borderRadius,
    },
    option: {
        color: primitiveColorTokens.blue[850],
        selectedBackground: primitiveColorTokens.translucentBlue["500"],
        selectedFocusBackground: primitiveColorTokens.translucentBlue["500"],
        selectedColor: primitiveColorTokens.blue[625],
        borderRadius: primitiveLayoutTokens.borderRadius,
    },
    css: () => {
        /**
         * Base Overrides for p-select
         */
        const base = `
            .p-select:not(.p-disabled):hover {
                border-color: #053368;
                background-color: #d4e8fe;
            }
        `;

        return base;
    },
};
